import { render, staticRenderFns } from "./mc-modul.vue?vue&type=template&id=aeeb2b7e&scoped=true"
import script from "./mc-modul.vue?vue&type=script&lang=js"
export * from "./mc-modul.vue?vue&type=script&lang=js"
import style0 from "./mc-modul.vue?vue&type=style&index=0&id=aeeb2b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeb2b7e",
  null
  
)

export default component.exports